import { ApiResult, HttpClient } from "../http.js";
import {
  KlsCompetencyProfileDto,
  KlsCompetencyCategory,
  KlsCompetencyLevel,
  KlsCertificationStatus,
} from "../types/kls-competencies.js";

export interface KlsCompetencyPayload {
  id: string;
  name: string;
  category: KlsCompetencyCategory;
  level: KlsCompetencyLevel;
  verifiedById?: string | null;
  verifiedByName?: string | null;
  verifiedAt?: string | null;
  notes?: string | null;
}

export interface KlsCertificationPayload {
  id: string;
  name: string;
  issuer: string;
  certificationNumber?: string | null;
  issueDate: string;
  expiryDate?: string | null;
  documentUrl?: string | null;
  status: KlsCertificationStatus;
}

export interface CreateKlsCompetencyProfilePayload {
  userId: string;
  userName: string;
  competencies?: KlsCompetencyPayload[] | null;
  certifications?: KlsCertificationPayload[] | null;
  lastReviewDate?: string | null;
  nextReviewDate?: string | null;
  notes?: string | null;
  id?: string;
}

export interface UpdateKlsCompetencyProfilePayload {
  userId: string;
  userName: string;
  competencies?: KlsCompetencyPayload[] | null;
  certifications?: KlsCertificationPayload[] | null;
  lastReviewDate?: string | null;
  nextReviewDate?: string | null;
  notes?: string | null;
}

export interface ListKlsCompetencyProfilesQuery {
  userId?: string;
}

export class KlsCompetenciesApi {
  constructor(private readonly http: HttpClient) {}

  list(query: ListKlsCompetencyProfilesQuery = {}): Promise<ApiResult<KlsCompetencyProfileDto[]>> {
    return this.http.get<KlsCompetencyProfileDto[]>("/api/kls-competencies", { query: { ...query } });
  }

  get(id: string): Promise<ApiResult<KlsCompetencyProfileDto>> {
    return this.http.get<KlsCompetencyProfileDto>(`/api/kls-competencies/${encodeURIComponent(id)}`);
  }

  create(payload: CreateKlsCompetencyProfilePayload): Promise<ApiResult<string>> {
    return this.http.post<string>("/api/kls-competencies", { body: payload });
  }

  update(id: string, payload: UpdateKlsCompetencyProfilePayload): Promise<ApiResult<KlsCompetencyProfileDto>> {
    return this.http.put<KlsCompetencyProfileDto>(`/api/kls-competencies/${encodeURIComponent(id)}`, { body: payload });
  }

  remove(id: string): Promise<ApiResult<string>> {
    return this.http.delete<string>(`/api/kls-competencies/${encodeURIComponent(id)}`);
  }
}
